export const apiOrigin = process.env.REACT_APP_API_URL || '';

export const pfidClientID = process.env.REACT_APP_PFID_CLIENT_ID || '';
export const pfidClientSecret = process.env.REACT_APP_PFID_CLIENT_SECRET || '';
export const pfidConnectionUrl = process.env.REACT_APP_PFID_CONNECTION_URL || '';
export const pfidGetTokenUrl = process.env.REACT_APP_PFID_GET_TOKEN_URL || '';
export const pfidCreateAccountUrl = process.env.REACT_APP_PFID_CREATE_ACCOUNT_URL || '';
export const pfidRedirectUri = process.env.REACT_APP_PFID_REDIRECT_URI || '';

export const appName = process.env.REACT_APP_NAME || 'Side Onco Skin';
